import StoredLayout from '../../layouts/StoredLayout'
import ReactDatetime from './ReactDatetime'
export default StoredLayout(ReactDatetime)



// WEBPACK FOOTER //
// ./src/forms/react-datetime/index.js